import React, { useState } from 'react';
import { BlockBulkUploadModal } from '@/components/features/resources/properties/BlockBulkUploadModal';

interface BulkBlocksCardProps {
  onNext: (createdBlockIds: string[]) => void;
  onBack: () => void;
}

export const BulkBlocksCard: React.FC<BulkBlocksCardProps> = ({
  onNext,
  onBack
}) => {
  const [isModalVisible, setIsModalVisible] = useState(true);

  const handleModalSuccess = () => {
    setIsModalVisible(false);
    // For now, we'll pass empty array since the modal handles the creation
    // In a real implementation, we might want to get the created block IDs from the modal
    onNext([]);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    onBack(); // Go back to block selection when modal is cancelled
  };

  return (
    <>
      {/* Bulk Upload Modal - Show immediately */}
      <BlockBulkUploadModal
        visible={isModalVisible}
        onCancel={handleModalCancel}
        onSuccess={handleModalSuccess}
      />
    </>
  );
};
